export const navigationV2 = {
  home: () => {
    return "/home";
  },
  dashboard: () => {
    return "/";
  },
  dashboardNotFound: () => {
    return "/not-found";
  },
  login: (searchParams?: URLSearchParams) => {
    return `/login${searchParams ? `?${searchParams.toString()}` : ""}`;
  },
  loginCallback: () => {
    return "/login/callback";
  },
  twoFactor: (searchParams?: URLSearchParams) => {
    const query = searchParams?.toString();

    return `/2fa${query ? `?${query}` : ""}`;
  },
  /**
   * `invitationId` keeps the wizard in "joining an existing practice" mode, so
   * it has to survive every step change and any reload of a deep link.
   */
  signUp: (step?: number, invitationId?: string | null) => {
    const params = new URLSearchParams();
    if (step) params.set("step", String(step));
    if (invitationId) params.set("invitationId", invitationId);
    const query = params.toString();

    return `/sign-up${query ? `?${query}` : ""}`;
  },
  visits: () => {
    return "/visits";
  },
  newVisit: () => {
    return "/visit/new";
  },
  visit: (encounterId: string | number) => {
    return `/visit/${encounterId}`;
  },
  patients: () => {
    return "/patients";
  },
  patientDetail: (patientId: string) => {
    return `/patients/${patientId}`;
  },
  patientVisits: (patientId: string) => {
    return `/patients/${patientId}/visits`;
  },
  documents: () => {
    return "/documents";
  },
  settings: () => {
    return "/settings";
  },
  settingsAccount: () => {
    return "/settings/account";
  },
  settingsPreferences: () => {
    return "/settings/preferences";
  },
  settingsPracticeInfo: () => {
    return "/settings/practice-info";
  },
  settingsSecurity: () => {
    return "/settings/security";
  },
  settingsTeam: () => {
    return "/settings/team";
  },
};
